export const LIST = "WITHDRAWAL_LISTING";
export const DROPDOWN = "WITHDRAWAL_DROPDOWN";
export const DETAILS = "WITHDRAWAL_DETAILS";
export const UPDATE = "WITHDRAWAL_UPDATE";
export const SYSALERT = "WITHDRAWAL_SYSALERT";
